import React, { useState, CSSProperties } from "react";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";
import clsx from "clsx";
import pick from "lodash/pick";
import { useStyles } from "../DataTable.styles";
import { RenderCell } from "./RenderCell";

import { Column, TBodyProps } from "../DataTable.type";
import { CacheInvalidationAction } from "$utils/cache";
import { TableRowError } from "./TableRowError";
import { getColumnWidths } from "../utils";

export const TBody = ({
  thead, // SEE move this in the provider i think
  data,
  isRowRelative = false, // TODO this will be remove
  noPointer = false, // TODO this will be remove and depend on the row click Action
  noHover = false, // TODO this will be remove and depend on the row click Action
  CollapsedChildren,
  queryFunctionName = null, // @fixme: remove this when op without edb will be fixed
}: TBodyProps<typeof data>) => {
  const classes = useStyles();
  const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});
  const columnWidths = getColumnWidths(thead ?? []);

  const toggleRowExpansion = (index: number) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <TableBody>
      {data.map((row: any, idx: number) => {
        // for now all rows are expandable, refacto for conditionnal comming in BL-625
        const isExpandable = CollapsedChildren || false; //  row.isExpandable &&
        const rowToDisplay =
          queryFunctionName !== CacheInvalidationAction.GET_OPS || row.edb;
        if (!rowToDisplay)
          return <TableRowError key={`row-error-${idx}`} op={row} idx={idx} />;
        return (
          <React.Fragment key={`row-${idx}`}>
            <TableRow
              className={clsx(
                classes.TableRow,
                noPointer ? "nopointer" : "",
                isRowRelative ? classes.relative : null
              )}
              data-testid={`row-${idx}`}
              onClick={() => isExpandable && toggleRowExpansion(idx)}
              hover={!noHover}
            >
              {thead?.map((column: Column, index: number) => {
                const styles = pick(column, [
                  "rowStyle",
                  "color",
                ]) as unknown as CSSProperties;
                return (
                  <TableCell
                    key={`row-${idx}-cell-${index}`}
                    scope="row"
                    align={column?.align}
                    onClick={
                      column.cell.onClick
                        ? () => column.cell.onClick(row)
                        : undefined
                    }
                    className={clsx(
                      (
                        typeof column.cell.isDisabled === "function"
                          ? column.cell.isDisabled(row)
                          : column.cell.isDisabled
                      )
                        ? "disabled"
                        : "",
                      classes.tableCell
                      // customCellClass || "" //TODO put this in Column
                    )}
                    style={{ ...styles, width: columnWidths[index] }}
                    padding="none"
                  >
                    <Box className={classes.tableCellIn}>
                      <RenderCell {...column.cell} row={row} />
                    </Box>
                  </TableCell>
                );
              })}
            </TableRow>

            {isExpandable && expandedRows[idx] && (
              <TableRow>
                <TableCell colSpan={thead.length}>
                  <Box>
                    <CollapsedChildren row={row} />
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
        );
      })}
    </TableBody>
  );
};
